export default __webpack_public_path__ + "static/media/chat.23d62871.svg";